var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticStyle:{"padding":"0px","height":"100%","margin":"0px"}},[_c('v-col',{staticStyle:{"height":"100%","padding-bottom":"0px"},attrs:{"cols":"12"}},[_c('h1',[_vm._v("Pendiente")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }